module.exports = __webpack_public_path__ + "img/rawpixel-597770.98f35231.jpg";